import {
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'egi-card',
  templateUrl: './egi-card.component.html',
  styleUrls: ['./egi-card.component.css'],
})
export class EgiCardComponent implements OnInit {
  @ContentChild('headerTemplate') headerTemplate: TemplateRef<any>;
  @Input() title?: string;
  @Input() headerContent: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  hasHeaderContent(): boolean {
    return this.headerTemplate !== undefined || !!this.title;
  }
}
